<template>
  <DecoratedSubtitle
    v-bind:title="title"
    class="centered-decorated-subtitle"
    v-if="title !== ''"
  />
  <div v-for="(paragraph, index) in paragraphs" :key="index">
    <p v-html="paragraph" v-if="typeof paragraph === 'string'"></p>
    <ul v-if="typeof paragraph === 'object'">
      <li v-for="(item, index) in paragraph" :key="index" v-html="item"></li>
    </ul>
  </div>
</template>

<script>
import DecoratedSubtitle from "@/components/staticpages/DecoratedSubtitle";

export default {
  name: "StyledParagraph",
  components: {
    DecoratedSubtitle,
  },
  props: {
    title: String,
    paragraphs: {
      Array,
      default: () => [
        "This will be rendered as p",
        "This will be rendered as p",
        ["This will be rendered as ul", "This will be renderd as ul"],
      ],
    },
  },
};
</script>

<style scoped lang="scss">
.centered-decorated-subtitle {
  width: 50%;
  margin-left: auto;
  margin-right: auto;
}
</style>
